export const singleproductreq="singlereq"
export const singleproductsucc="singlsucc"
export const singleproductfail="singlefail"